const principles = [
  {
    title: "Be a maker",
    subtitle: "Make ideas tangible, iterate often, and refine with purpose",
    images: [
      "https://ir.ebaystatic.com/cr/v/c01/ebay-design/principle-1-image-1.jpg",
      "https://ir.ebaystatic.com/cr/v/c01/ebay-design/principle-1-image-2.jpg",
      "https://ir.ebaystatic.com/cr/v/c01/ebay-design/principle-1-image-3.jpg",
      "https://ir.ebaystatic.com/cr/v/c01/ebay-design/principle-1-image-4.jpg",
    ],
  },
  {
    title: "Know why",
    subtitle: "Ask the big—and small—questions",
    images: [
      "https://ir.ebaystatic.com/cr/v/c01/ebay-design/principle-2-image-1.jpg",
      "https://ir.ebaystatic.com/cr/v/c01/ebay-design/principle-2-image-2.jpg",
      "https://ir.ebaystatic.com/cr/v/c01/ebay-design/principle-2-image-3.jpg",
      "https://ir.ebaystatic.com/cr/v/c01/ebay-design/principle-2-image-4.jpg",
    ],
  },
  {
    title: "Take risks",
    subtitle: "Understand the parameters, and then push the limits",
    images: [
      "https://ir.ebaystatic.com/cr/v/c01/ebay-design/principle-3-image-1.jpg",
      "https://ir.ebaystatic.com/cr/v/c01/ebay-design/principle-3-image-2.jpg",
      "https://ir.ebaystatic.com/cr/v/c01/ebay-design/principle-3-image-3.jpg",
      "https://ir.ebaystatic.com/cr/v/c01/ebay-design/principle-3-image-4.jpg",
    ],
  },
  {
    title: "Better together",
    subtitle: "Our best work is greater than the sum of its parts",
    images: [
      "https://ir.ebaystatic.com/cr/v/c01/ebay-design/principle-4-image-1.jpg",
      "https://ir.ebaystatic.com/cr/v/c01/ebay-design/principle-4-image-2.jpg",
      "https://ir.ebaystatic.com/cr/v/c01/ebay-design/principle-4-image-3.jpg",
      "https://ir.ebaystatic.com/cr/v/c01/ebay-design/principle-4-image-4.jpg",
    ],
  },
  {
    title: "Raise the bar",
    subtitle: "If it’s worth doing, it’s worth doing well",
    images: [
      "https://ir.ebaystatic.com/cr/v/c01/ebay-design/principle-5-image-1.jpg",
      "https://ir.ebaystatic.com/cr/v/c01/ebay-design/principle-5-image-2.jpg",
      "https://ir.ebaystatic.com/cr/v/c01/ebay-design/principle-5-image-3.jpg",
      "https://ir.ebaystatic.com/cr/v/c01/ebay-design/principle-5-image-4.jpg",
    ],
  },
  {
    title: "Always be learning",
    subtitle: "Seek out new experiences, tools, and minds",
    images: [
      "https://ir.ebaystatic.com/cr/v/c01/ebay-design/principle-6-image-1.jpg",
      "https://ir.ebaystatic.com/cr/v/c01/ebay-design/principle-6-image-2.jpg",
      "https://ir.ebaystatic.com/cr/v/c01/ebay-design/principle-6-image-3.jpg",
      "https://ir.ebaystatic.com/cr/v/c01/ebay-design/principle-6-image-4.jpg",
    ],
  },
];

const principlesImagesAltText = [
  "A collage of photos featuring collectors holding up trading cards, a woman applying eBay branded tape to a shipping box, and the exterior of an eBay corporate office.",
  "A collage of photos, featuring a woman writing on a whiteboard, a man standing proudly in front of a clothing rack, two people in trendy clothes posing in a product photo, and a line of diverse women standing together inside an office.",
  "A collage of photos featuring a group of presenters on stage beneath a large eBay logo sign, a woman laughing covering her face with her hand, a collection of trading cards in protective sleeves, and a large crowd of people indoors at a corporate event.",
  "A collage of photos featuring a blue trade show booth display with a bright neon checkmark sign and the words “Authenticity Guarantee,” a person facing away showing the back of a blue varsity style jacket, two people laughing together at a conference, and a row of people clapping watching a show.",
  "A collage of photos featuring collectors holding up a trading card, a man standing proudly by a rack of clothing items, a woman applying eBay branded tape to a shipping box, and the exterior of an eBay corporate office.",
  "A collage of photos featuring a crowd of people with arms raised seated at an event, a young man seated at a table, photographing watches with a mobile device, a close up photo of a hand with an elegant watch, and two speakers on stage in front of a banner that reads, “with AI”.",
];

const principlesImages = Array.from(
  { length: principles[0].images.length },
  (_, imageIndex) =>
    principles.map((principle) => principle.images[imageIndex]),
);

export { principles, principlesImages, principlesImagesAltText };
